import { ChatSDK } from '@tencentcloud/chat';
import {
  UIKitProvider,
  Chat,
  ChatHeader,
  MessageList,
  MessageInput,
} from '@tencentcloud/chat-uikit-react';
import Mobile from '@/layout/Mobile';
import { useOutlet } from '@/context/OutletContext';

import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';

interface IChatboxProps {
  chat?: ChatSDK;
  customClasses?: string;
}

function Chatbox({ chat, customClasses }: IChatboxProps) {
  const { env, theme, language } = useOutlet();

  const ChatBoxUIKit = (
    <UIKitProvider
      chat={chat}
      theme={theme}
      language={language}
      customClasses={customClasses}
    >
      <Chat>
        <ChatHeader />
        <MessageList />
        <MessageInput />
      </Chat>
    </UIKitProvider>
  );

  return env === 'web' ? ChatBoxUIKit : <Mobile>{ChatBoxUIKit}</Mobile>;
}

export default Chatbox;
